import React from 'react';
import { Card, Box } from '@mui/material';
import { useTheme } from '@mui/material/styles';

const GlassCard = ({ children, sx = {}, hoverEffect = true, ...props }) => {
    const theme = useTheme();

    return (
        <Card
            sx={{
                // Styles are already defined in theme.js under MuiCard override
                // But we can add specific local overrides here if needed
                position: 'relative',
                overflow: 'hidden',
                ...sx,
                // If hoverEffect is explicitly false, disable the hover transform
                ...(!hoverEffect && {
                    '&:hover': {
                        transform: 'none',
                        boxShadow: theme.components?.MuiCard?.styleOverrides?.root?.boxShadow
                    }
                })
            }}
            {...props}
        >
            {/* Optional: Add a shine effect container if needed */}
            <Box sx={{ position: 'relative', zIndex: 1 }}>
                {children}
            </Box>
        </Card>
    );
};

export default GlassCard;
